// import { scrollToElement } from 'src/app/shared/utilities/utils';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss']
})
export class DropdownSelectComponent implements OnChanges {
  uniqueId: string = uuidv4();

  @Input()
  dataArray: any[] | undefined = [];

  @Input()
  keyName: string[] = [];

  @Input()
  keyId: string = "";

  @Input()
  selectedObject: any;

  @Input()
  translateKey: string = "";

  @Input()
  placeholder: string = "";

  @Input()
  loading: boolean = false

  @Input()
  error: boolean = false;

  @Input()
  showAbsolute: boolean = true;

  @Input() useIdAsModel: boolean = false; // New: use when only the selected item's ID is provided, not the full object

  @Input() scrollParentId: string = ""

  @Input() scrollChildId: string = ""

  @Input() disabled: boolean = false;

  @Output()
  optionEmitter = new EventEmitter();

  openDropdown = false;

  selectedItem: any = null;

  ngOnChanges(changes: SimpleChanges) {
    this.setLoadingStatus()

    if (this.dataArray && this.selectedObject !== undefined) {
      this.selectedItem = this.useIdAsModel
        ? this.dataArray.find(item => item[this.keyId] === this.selectedObject) || null
        : this.selectedObject;
    }
  }

  setLoadingStatus() {
    if (this.loading) {
      this.openDropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.loading && !this.disabled) {
      this.openDropdown = !this.openDropdown;
    }
    if (this.openDropdown) this.scrollElementIntoView();
  }

  selectOption(option: any) {
    const output = this.useIdAsModel ? option[this.keyId] : option;
    this.optionEmitter.emit(output);
    this.openDropdown = false;
  }

  isSelected(item: any): boolean {
    if (!this.selectedObject) return false;
    if (this.useIdAsModel) {
      return this.selectedObject === item[this.keyId];
    }
    return this.selectedObject?.[this.keyId] === item[this.keyId];
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.uniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }

  }

  private scrollElementIntoView() {
    // if (this.scrollParentId && this.scrollChildId)
    // scrollToElement(this.scrollParentId, this.scrollChildId)
  }
}
